import request from "@/utils/request";
import config from "@/utils/config";

/**
 * @description: 后台分页获取设备反馈信息记录集合
 * @param {*} params
 * @return {*}
 */
export function getDeviceFeedbackList(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminFeedback/Device/List",
        method: "get",
        params,
    });
}

/**
 * @description: 后台获取指定设备反馈信息记录详情
 * @param {*} params
 * @return {*}
 */
export function getDeviceFeedbackOne(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminFeedback/Device/One",
        method: "get",
        params,
    });
}

/**
 * @description: 后台分页获取用户反馈信息记录集合
 * @param {*} params
 * @return {*}
 */
export function getUserFeedbackList(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminFeedback/List",
        method: "get",
        params,
    });
}

/**
 * @description: 后台获取指定用户反馈信息记录详情
 * @param {*} params
 * @return {*}
 */
export function getUserFeedbackOne(params) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminFeedback/One",
        method: "get",
        params,
    });
}